import CommonError from '../Common/CommonError'
import { error500 } from '../ErrorSvg'

const Error500Container = () => {
  return (
    <CommonError src={error500} />
  )
}

export default Error500Container